import React, { Component } from 'react';
import Navigation from './Navigation';
import PeriodicTable from './PeriodicTable';
import DelayLink from './DelayLink';

import health from './img/icon-healthcare.svg';
import retail from './img/icon-retail.svg';
import education from './img/icon-highered.svg';
import './css/SelectVertical.scss';
import './css/animate.css';

class SelectVertical extends Component {

  constructor(props) {
    super(props);

    this.state = {
      headerAnimate: "fadeInUp",
      verticalAnimate: "animated bounceInUp",
      verticalSelected: false
    }

  }


  verticalClick(e) {
    this.setState({
      headerAnimate: "fadeOutUp",
      verticalAnimate: "animated bounceOutUp",
      verticalSelected: true,
      verticalName: e.target.dataset.vertical
    });

    console.log(e.target.dataset.vertical);

  }

  render() {

    return (



      <div className="SelectVertical">
        <h2 className={"animated " + this.state.headerAnimate}>Select Industry</h2>

        <div className={"vertical health vertical1 " + (this.state.verticalName === 'health' ? 'moveUpHealth' : this.state.verticalAnimate)}>

          <img src={health}
            onClick={this.verticalClick.bind(this)}
            data-vertical="health"
          />
          <h3>Healthcare</h3>
        </div>

        <div className={"vertical retail vertical2 " + this.state.verticalAnimate}>

          <img src={retail}
            onClick={this.verticalClick.bind(this)}
            data-vertical="retail"
          />
          <h3>Retail</h3>
        </div>

        <div className={"vertical education vertical3 " + this.state.verticalAnimate}>

          <img src={education}
            onClick={this.verticalClick.bind(this)}
            data-vertical="education"
          />
          <h3>Education</h3>
        </div>


      </div>

    );
  }
}

export default SelectVertical;
